import { supabase } from '../../supabase'
import type { DatabaseRow, RepositoryResult } from '../types/database.types'
import { failure, success } from './result'

export const DuplicatesRepository = {
  async check(
    functionName: string,
    parameters: Record<string, unknown>,
  ): Promise<RepositoryResult<DatabaseRow[]>> {
    const { data, error } = await supabase.rpc(functionName, parameters)

    return error ? failure(error) : success((data ?? []) as DatabaseRow[])
  },
}
